module.exports = __webpack_public_path__ + "img/top.9c3cd912.jpg";